import axios from "axios";
import config from "../../config";
import './Results.css'
import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import scrollToTop from "../../scripts/scroll-to-top";

const EMAIL_REGEXP = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;

function Results() {
    const userName = window.localStorage.getItem('name');
    const { t, i18n } = useTranslation();

    const [formSubmitted, setFormSubmitted] = useState(false);
    const [email, setEmail] = useState('');
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const [loaderIsActive, setLoaderIsActive] = useState(false);

    const submitForm = async () => {
        if (!email) {
            setErrorMessage(t('Complete the required field'));
            return;
        }

        if(!EMAIL_REGEXP.test(email)) {
            setErrorMessage(t('Email address can not be recognized'));
            return;
        }

        try {
            setLoaderIsActive(true);

            await axios.post(
                config.API_URL_FOR_LOCAL_DEVELOPMENT + '/api/v1/landing/user/store',
                {
                    id: window.localStorage.getItem('landingUserId'),
                    emailAddress: email,
                    session: config.SESSION,
                },
            );

            setFormSubmitted(true);
            setErrorMessage(null);
        } catch (error) {
            console.error('Error while sending data:', error);
        } finally {
            setLoaderIsActive(false);
        }
    }

    useEffect(() => {
        scrollToTop();
    }, [])

    return (
        <div className="Results text-center">
            {!formSubmitted && <h1 className='title-1 mb-3'>{t("Results Page Title")}</h1>}

            <div className='position-relative'>
                {
                    !formSubmitted &&
                    <input
                        className='input-1 mb-2 mb-md-3 mr-0'
                        onChange={(e) => setEmail(e.target.value)}
                        type="email"
                        placeholder='Email address'
                    />
                }

                {
                    !formSubmitted &&
                    <div className='d-flex flex-column align-items-center mb-35'>
                        {
                            errorMessage && <div className='form-error mb-15'>{errorMessage}</div>
                        }

                        <button
                            type='submit'
                            className='button-1'
                            onClick={() => submitForm()}
                        >
                            {t("Submit Button")}
                        </button>
                    </div>
                }

                {loaderIsActive && <div className='submitting-overlay'></div>}
            </div>

            {
                formSubmitted &&
                <div className='box-1 text-start' style={{whiteSpace: 'pre-line'}}>
                    <p dangerouslySetInnerHTML={{__html: t("Result Page Success Message", {name: userName})}} />
                </div>
            }
        </div>
    );
}

export default Results;
